export function isProjectBlurred(blurTags: string[], userTags?: string[]) {
  if (blurTags != null && blurTags.length === 0) return false

  if (userTags == null || userTags.length === 0) return true

  return !blurTags.some((tag) => userTags.includes(tag))
}
